import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IntegrationCardWrapper = styled.div`
  padding: ${Spacing.S16};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};
`
